/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

export enum ConsoleInstanceMatrixPlan {
  assetCount = 'asset_count',
}

export enum ConsoleInstanceMatrixEnvironment {
  canary = 'canary',
  dedicated = 'dedicated',
  development = 'development',
  evaluation = 'evaluation',
  internal = 'internal',
  production = 'production',
}
